import { render, staticRenderFns } from "./edit-marketplace-item.vue?vue&type=template&id=0626e456&"
import script from "./edit-marketplace-item.vue?vue&type=script&lang=js&"
export * from "./edit-marketplace-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports